// src/components/exam-player/PartNav.jsx
import React, { useMemo } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function PartNav({
  parts, // [{ pid, startQi, endQi, count, firstPageIdx }]
  activePartIndex = 0, // 0-based
  activeQuestion1Based, // 1-based (اختیاری)
  displayMode, // "one_per_page" | "all_at_once"
  onGoPart, // (index) => void
  onGoQuestion, // (qi0) => void  // فقط one_per_page
}) {
  const isOnePer = displayMode !== "all_at_once";

  const safeIndex =
    Number.isInteger(activePartIndex) &&
    activePartIndex >= 0 &&
    activePartIndex < (parts?.length || 0)
      ? activePartIndex
      : 0;

  const activePart = parts?.[safeIndex] || null;

  // کمک‌کننده: تبدیل مشخصات هر پارت به آرایه 1-بیس شماره‌سؤال‌ها
  const rangeFor = (p) => {
    if (!p) return [];
    const s1 = Number(p.startQi); // 1-based
    const e1 = Number(
      p.endQi != null ? p.endQi : s1 + (Number(p.count) || 0) - 1,
    );
    if (!s1 || !e1 || e1 < s1) return [];
    return Array.from({ length: e1 - s1 + 1 }, (_, i) => s1 + i);
  };

  // فقط برای اکتیو نیاز داریم، ولی برای تمیزی هر پارت هم می‌تونیم بسازیم
  const activeRange = useMemo(() => rangeFor(activePart), [activePart]);

  const goPrevPart = () => onGoPart?.(Math.max(0, safeIndex - 1));
  const goNextPart = () =>
    onGoPart?.(Math.min((parts?.length || 1) - 1, safeIndex + 1));

  return (
    <>
      {/* نوار پایین ثابت */}
      <div
        dir="ltr"
        className="fixed bottom-0 left-0 right-0 z-30 bg-white/95 backdrop-blur border-t"
      >
        <div className="px-4">
          {/* ردیف: لیبل پارت‌ها؛ وقتی اکتیو باشد اعداد جلوی خودش می‌آیند */}
          <div className="relative">
            {/* خط‌های باریک بالایی صرفاً برای ظاهر */}
            <div className="absolute -top-1 left-0 right-0 flex">
              {(parts || []).map((_, i) => (
                <div key={`tick-${i}`} className="flex-1 px-2">
                  <div className="h-[3px] bg-gray-200 mx-auto w-24 rounded-full" />
                </div>
              ))}
            </div>

            <div className="flex items-center gap-2 text-gray-800 pt-3">
              {(parts || []).map((p, i) => {
                const isActive = i === safeIndex;
                const myRange = isActive ? activeRange : []; // فقط اکتیو نشان بده
                return (
                  <div
                    key={p?.pid || `__none_${i}`}
                    className="flex-1 flex items-center justify-center gap-2 min-w-0"
                  >
                    <button
                      onClick={() => onGoPart?.(i)}
                      className={`shrink-0 px-2 py-2 rounded transition ${
                        isActive
                          ? "font-semibold text-gray-900"
                          : "text-gray-700 hover:text-gray-900"
                      }`}
                      aria-current={isActive ? "page" : undefined}
                      title={p?.label || p?.pid || `Part ${i + 1}`}
                    >
                      {`Part ${i + 1}`}
                    </button>

                    {/* شماره‌ سؤالاتِ همین پارت، روبروی خودش */}
                    {myRange.length > 0 && (
                      <div className="flex items-center gap-2 overflow-x-auto hide-scrollbar">
                        {myRange.map((q1) => {
                          const isQActive = q1 === activeQuestion1Based; // هر دو 1-based

                          console.log(q1);
                          return (
                            <button
                              type="button"
                              onClick={() => {
                                if (isOnePer) {
                                  onGoQuestion?.(q1 - 1);
                                }

                                document
                                  .getElementById(`item-${q1}`)
                                  ?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                  });
                              }}
                              className={[
                                "w-8 h-8 grid place-items-center rounded text-sm border whitespace-nowrap",
                                isQActive
                                  ? "border-indigo-500 text-indigo-600"
                                  : "border-gray-200 hover:border-gray-300",
                              ].join(" ")}
                              aria-current={isQActive ? "true" : undefined}
                              aria-label={`Question ${q1}`}
                            >
                              {q1}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* کنترل‌های شناور سمت راست */}
      <div className="fixed right-4 bottom-24 z-40 flex flex-col gap-2">
        <button
          onClick={goPrevPart}
          className="w-10 h-10 grid place-items-center rounded bg-black text-white hover:opacity-90"
          title="Previous part"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={goNextPart}
          className="w-10 h-10 grid place-items-center rounded bg-black text-white hover:opacity-90"
          title="Next part"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </>
  );
}

/* اختیاری: مخفی کردن اسکرول افقی ریز (اگر سوال‌ها زیاد شدند)
.hide-scrollbar::-webkit-scrollbar { display: none; }
.hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
*/
